import api from "@/services/api";

export interface GgColaboradorDto {
  id: string;
  nome: string;
  usuario: string;
  setor: string | null;
  cargo: string | null;
  telefone: string | null;
  email: string | null;
  liderId: string | null;
  liderNome?: string | null;
  liderUsuario?: string | null;
  ativo: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface GgPesquisaListDto {
  id: string;
  titulo: string;
  descricao: string | null;
  nomeEmpresa: string;
  slug: string;
  status: "RASCUNHO" | "ATIVA" | "ENCERRADA";
  modoPrivacidade: "CONFIDENCIAL" | "IDENTIFICADA";
  permiteLinkGeral: boolean;
  dataInicio: string | null;
  dataFim: string | null;
  convidados: number;
  respostas: number;
  adesao: number | null;
  enps: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface GgPerguntaDto {
  id: string;
  pesquisaId: string;
  ordem: number;
  tipo: "NPS_0_10" | "ESCALA_1_5" | "TEXTO";
  indicador: "ENPS" | "NPS_PRODUTO" | null;
  dimensao: string | null;
  texto: string;
  obrigatoria: boolean;
}

export interface GgConviteDto {
  id: string;
  pesquisaId: string;
  colaboradorId: string;
  token: string;
  enviadoEm: string | null;
  abertoEm: string | null;
  respondidoEm: string | null;
  nome: string;
  usuario: string;
  setor: string | null;
  telefone: string | null;
  status: "Respondido" | "Aberto" | "Enviado" | "Não enviado";
  link: string;
}

export interface GgPesquisaDetalheDto {
  id: string;
  titulo: string;
  descricao: string | null;
  nomeEmpresa: string;
  slug: string;
  status: "RASCUNHO" | "ATIVA" | "ENCERRADA";
  modoPrivacidade: "CONFIDENCIAL" | "IDENTIFICADA";
  permiteLinkGeral: boolean;
  mensagemConvite: string | null;
  dataInicio: string | null;
  dataFim: string | null;
  linkGeral: string | null;
  perguntasBloqueadas: boolean;
  convidados: number;
  respostas: number;
  createdAt: string;
  updatedAt: string;
}

export interface GgResumoDto {
  colaboradoresAtivos: number;
  colaboradoresTotal: number;
  pesquisasAtivas: number;
  enps: number | null;
  adesao: number | null;
  pesquisa: { id: string; titulo: string; status: string } | null;
  ciclosAtivos: number;
  paresPendentes: number;
  lideresComNota: number;
}

export interface GgImportLinha {
  linha: number;
  nome: string;
  usuario: string;
  setor: string;
  telefone: string;
  liderUsuario: string;
  erro: string | null;
  duplicado: boolean;
}

export interface GgCompetenciaDto {
  id: string;
  codigo: string;
  nome: string;
  descricao: string | null;
  ativo: boolean;
  ordem: number;
}

export interface GgCicloListDto {
  id: string;
  titulo: string;
  descricao: string | null;
  nomeEmpresa: string;
  slug: string;
  status: "RASCUNHO" | "ATIVA" | "ENCERRADA";
  modoPrivacidade: "CONFIDENCIAL" | "IDENTIFICADA";
  dataInicio: string | null;
  dataFim: string | null;
  minRespondentes: number;
  convidados: number;
  respostas: number;
  adesao: number | null;
  lideres: number;
  createdAt: string;
  updatedAt: string;
}

export interface GgCicloDetalheDto {
  id: string;
  titulo: string;
  descricao: string | null;
  nomeEmpresa: string;
  slug: string;
  status: "RASCUNHO" | "ATIVA" | "ENCERRADA";
  modoPrivacidade: "CONFIDENCIAL" | "IDENTIFICADA";
  mensagemConvite: string | null;
  dataInicio: string | null;
  dataFim: string | null;
  minRespondentes: number;
  perguntasBloqueadas: boolean;
  convidados: number;
  respostas: number;
  createdAt: string;
  updatedAt: string;
}

export interface GgPerguntaLiderancaDto {
  id: string;
  cicloId: string;
  ordem: number;
  tipo: "ESCALA_1_5" | "TEXTO";
  competenciaId: string | null;
  competenciaNome: string | null;
  texto: string;
  obrigatoria: boolean;
  peso: number;
}

export interface GgConviteLiderancaDto {
  id: string;
  cicloId: string;
  colaboradorId: string;
  liderId: string;
  token: string;
  enviadoEm: string | null;
  abertoEm: string | null;
  respondidoEm: string | null;
  nome: string;
  usuario: string;
  setor: string | null;
  telefone: string | null;
  liderNome: string;
  status: "Respondido" | "Aberto" | "Enviado" | "Não enviado";
  link: string;
}

export interface GgParLiderancaDto {
  colaboradorId: string;
  colaboradorNome: string;
  setor: string | null;
  liderId: string;
  liderNome: string;
}

export interface GgLiderancaScorecardDto {
  liderId: string;
  liderNome: string;
  liderUsuario: string;
  setor: string | null;
  cargo: string | null;
  convidados: number;
  respondentes: number;
  adesao: number | null;
  oculto: boolean;
  motivo: string | null;
  notaGeral: number | null;
  zona: { id: string; label: string; cor: string } | null;
  competencias: Array<{
    competenciaId: string | null;
    competenciaNome: string;
    media: number | null;
    favorabilidade: number | null;
    total: number;
  }>;
}

export interface GgLiderancaResultadosDto {
  ciclo: {
    id: string;
    titulo: string;
    status: string;
    modoPrivacidade: string;
    nomeEmpresa: string;
    minRespondentes: number;
    perguntasBloqueadas: boolean;
  };
  cards: {
    respondentes: number;
    convidados: number;
    adesao: number | null;
    lideresAvaliados: number;
    lideresVisiveis: number;
    notaMedia: number | null;
    zona: { id: string; label: string; cor: string } | null;
  };
  ranking: GgLiderancaScorecardDto[];
  competencias: GgLiderancaScorecardDto["competencias"];
  comentarios: Array<{
    perguntaId: string;
    perguntaTexto: string;
    texto: string;
    liderId: string;
    liderNome: string;
    colaboradorNome: string | null;
    setor: string | null;
  }>;
}

export interface GgResultadosDto {
  pesquisa: {
    id: string;
    titulo: string;
    status: string;
    modoPrivacidade: string;
    nomeEmpresa: string;
    perguntasBloqueadas: boolean;
  };
  cards: {
    enps: number | null;
    zona: { id: string; label: string; cor: string } | null;
    respondentes: number;
    convidados: number;
    adesao: number | null;
    npsProduto: number | null;
    zonaProduto: { id: string; label: string; cor: string } | null;
  };
  npsBreakdown: {
    total: number;
    promotores: number;
    neutros: number;
    detratores: number;
    pctPromotores: number;
    pctNeutros: number;
    pctDetratores: number;
    enps: number | null;
  };
  distribuicao0a10: Array<{ nota: number; count: number }>;
  dimensoes: Array<{
    dimensao: string;
    label: string;
    media: number | null;
    favorabilidade: number | null;
    total: number;
    atencao: boolean;
  }>;
  porSetor: Array<{
    setor: string;
    respondentes: number;
    oculto: boolean;
    motivo: string | null;
    enps: number | null;
    dimensoes: Array<{ dimensao: string; label: string; media: number | null; favorabilidade: number | null }>;
  }>;
  comentarios: Array<{
    perguntaId: string;
    perguntaTexto: string;
    texto: string;
    grupo: "DETRATOR" | "NEUTRO" | "PROMOTOR" | null;
    colaboradorNome: string | null;
    colaboradorUsuario: string | null;
    setor: string | null;
  }>;
  adesaoPorSetor: Array<{
    setor: string;
    convidados: number;
    respostas: number;
    adesao: number | null;
    oculto: boolean;
  }>;
  adesaoPorDispositivo: Array<{ dispositivo: string; respostas: number; oculto: boolean }>;
  evolucao: Array<{ pesquisaId: string; titulo: string; data: string; enps: number | null }>;
  individuais: Array<{
    colaboradorId: string;
    nome: string;
    usuario: string;
    setor: string | null;
    itens: Array<{ perguntaId: string; valorNumero: number | null; valorTexto: string | null }>;
  }> | null;
}

export function extractGgError(e: unknown, fallback: string): string {
  const ax = e as { response?: { data?: { error?: string }; status?: number } };
  if (ax.response?.data?.error) return ax.response.data.error;
  if (ax.response?.status === 403) return "Sem permissão para Gente & Gestão.";
  if (e instanceof Error && e.message) return e.message;
  return fallback;
}

export async function fetchGgResumo(): Promise<GgResumoDto> {
  const { data } = await api.get<{ success: boolean } & GgResumoDto>("/api/gente-gestao/resumo");
  return data;
}

export async function fetchColaboradores(params: {
  q?: string;
  setor?: string;
  ativo?: string;
  page?: number;
  pageSize?: number;
}): Promise<{ total: number; page: number; pageSize: number; colaboradores: GgColaboradorDto[] }> {
  const { data } = await api.get("/api/gente-gestao/colaboradores", { params });
  return data;
}

export async function fetchSetores(): Promise<string[]> {
  const { data } = await api.get<{ success: boolean; setores: string[] }>(
    "/api/gente-gestao/colaboradores/setores",
  );
  return data.setores;
}

export async function sugerirUsuarioApi(nome: string, exceptoId?: string): Promise<string> {
  const { data } = await api.get<{ success: boolean; usuario: string }>(
    "/api/gente-gestao/colaboradores/sugerir-usuario",
    { params: { nome, exceptoId } },
  );
  return data.usuario;
}

export async function createColaboradorApi(body: Partial<GgColaboradorDto> & { nome: string; usuario?: string }) {
  const { data } = await api.post<{ success: boolean; colaborador: GgColaboradorDto }>(
    "/api/gente-gestao/colaboradores",
    body,
  );
  return data.colaborador;
}

export async function updateColaboradorApi(
  id: string,
  body: Partial<GgColaboradorDto> & { nome: string; usuario: string },
) {
  const { data } = await api.patch<{ success: boolean; colaborador: GgColaboradorDto }>(
    `/api/gente-gestao/colaboradores/${id}`,
    body,
  );
  return data.colaborador;
}

export async function inativarColaboradorApi(id: string) {
  const { data } = await api.post<{ success: boolean; colaborador: GgColaboradorDto }>(
    `/api/gente-gestao/colaboradores/${id}/inativar`,
  );
  return data.colaborador;
}

export async function previewImportacaoApi(texto: string): Promise<GgImportLinha[]> {
  const { data } = await api.post<{ success: boolean; linhas: GgImportLinha[] }>(
    "/api/gente-gestao/colaboradores/preview-importacao",
    { texto },
  );
  return data.linhas;
}

export async function importarColaboradoresApi(linhas: GgImportLinha[]) {
  const { data } = await api.post<{ success: boolean; criados: number; ignorados: number }>(
    "/api/gente-gestao/colaboradores/importar",
    { linhas },
  );
  return data;
}

export async function fetchPesquisas(): Promise<GgPesquisaListDto[]> {
  const { data } = await api.get<{ success: boolean; pesquisas: GgPesquisaListDto[] }>("/api/gente-gestao/nps");
  return data.pesquisas;
}

export async function createPesquisaApi(body: {
  titulo: string;
  nomeEmpresa: string;
  descricao?: string;
  modelo: "completo" | "rapido" | "branco";
  modoPrivacidade: "CONFIDENCIAL" | "IDENTIFICADA";
  permiteLinkGeral: boolean;
  dataInicio?: string;
  dataFim?: string;
}) {
  const { data } = await api.post("/api/gente-gestao/nps", body);
  return data as { success: boolean; pesquisa: GgPesquisaDetalheDto };
}

export async function fetchPesquisaDetalhe(id: string): Promise<{
  pesquisa: GgPesquisaDetalheDto;
  perguntas: GgPerguntaDto[];
  convites: GgConviteDto[];
  colaboradoresAtivos: GgColaboradorDto[];
}> {
  const { data } = await api.get(`/api/gente-gestao/nps/${id}`);
  return data;
}

export async function updatePesquisaApi(id: string, body: Record<string, unknown>) {
  const { data } = await api.patch(`/api/gente-gestao/nps/${id}`, body);
  return data.pesquisa as GgPesquisaDetalheDto;
}

export async function setStatusPesquisaApi(id: string, status: "RASCUNHO" | "ATIVA" | "ENCERRADA") {
  const { data } = await api.post(`/api/gente-gestao/nps/${id}/status`, { status });
  return data.pesquisa as GgPesquisaDetalheDto;
}

export async function addPerguntaApi(pesquisaId: string, body: Partial<GgPerguntaDto> & { tipo: string; texto: string }) {
  const { data } = await api.post(`/api/gente-gestao/nps/${pesquisaId}/perguntas`, body);
  return data.pergunta as GgPerguntaDto;
}

export async function updatePerguntaApi(pesquisaId: string, perguntaId: string, body: Partial<GgPerguntaDto>) {
  const { data } = await api.patch(`/api/gente-gestao/nps/${pesquisaId}/perguntas/${perguntaId}`, body);
  return data.pergunta as GgPerguntaDto;
}

export async function removePerguntaApi(pesquisaId: string, perguntaId: string) {
  await api.delete(`/api/gente-gestao/nps/${pesquisaId}/perguntas/${perguntaId}`);
}

export async function moverPerguntaApi(pesquisaId: string, perguntaId: string, direcao: "up" | "down") {
  const { data } = await api.post(`/api/gente-gestao/nps/${pesquisaId}/perguntas/${perguntaId}/mover`, { direcao });
  return data.perguntas as GgPerguntaDto[];
}

export async function gerarConvitesApi(
  pesquisaId: string,
  body: { colaboradorIds?: string[]; todosAtivos?: boolean; setor?: string | null },
) {
  const { data } = await api.post<{ success: boolean; criados: number }>(
    `/api/gente-gestao/nps/${pesquisaId}/convites`,
    body,
  );
  return data.criados;
}

export async function marcarEnviadoApi(pesquisaId: string, conviteId: string) {
  await api.post(`/api/gente-gestao/nps/${pesquisaId}/convites/${conviteId}/marcar-enviado`);
}

export async function fetchResultados(id: string): Promise<GgResultadosDto> {
  const { data } = await api.get<{ success: boolean; resultados: GgResultadosDto }>(
    `/api/gente-gestao/nps/${id}/resultados`,
  );
  return data.resultados;
}

export function csvColaboradoresUrl(): string {
  return "/api/gente-gestao/colaboradores/export.csv";
}

export function csvConvitesUrl(id: string): string {
  return `/api/gente-gestao/nps/${id}/convites.csv`;
}

export function csvRespostasUrl(id: string): string {
  return `/api/gente-gestao/nps/${id}/resultados.csv`;
}

export async function downloadGgCsv(url: string, filename: string): Promise<void> {
  const { data } = await api.get<Blob>(url, { responseType: "blob" });
  const blob = new Blob([data], { type: "text/csv;charset=utf-8" });
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}

export async function fetchColaboradoresOpcoes(): Promise<Array<{ id: string; nome: string; usuario: string; setor: string | null }>> {
  const { data } = await api.get("/api/gente-gestao/colaboradores/opcoes");
  return data.colaboradores;
}

export async function fetchCompetencias(): Promise<GgCompetenciaDto[]> {
  const { data } = await api.get<{ success: boolean; competencias: GgCompetenciaDto[] }>(
    "/api/gente-gestao/lideranca/competencias",
  );
  return data.competencias;
}

export async function createCompetenciaApi(body: { nome: string; descricao?: string; codigo?: string }) {
  const { data } = await api.post("/api/gente-gestao/lideranca/competencias", body);
  return data.competencia as GgCompetenciaDto;
}

export async function updateCompetenciaApi(id: string, body: Partial<GgCompetenciaDto>) {
  const { data } = await api.patch(`/api/gente-gestao/lideranca/competencias/${id}`, body);
  return data.competencia as GgCompetenciaDto;
}

export async function removeCompetenciaApi(id: string) {
  await api.delete(`/api/gente-gestao/lideranca/competencias/${id}`);
}

export async function moverCompetenciaApi(id: string, direcao: "up" | "down") {
  const { data } = await api.post(`/api/gente-gestao/lideranca/competencias/${id}/mover`, { direcao });
  return data.competencias as GgCompetenciaDto[];
}

export async function fetchCiclos(): Promise<{ ciclos: GgCicloListDto[]; pares: GgParLiderancaDto[] }> {
  const { data } = await api.get("/api/gente-gestao/lideranca/ciclos");
  return data;
}

export async function createCicloApi(body: {
  titulo: string;
  nomeEmpresa: string;
  descricao?: string;
  modelo: "completo" | "rapido" | "branco";
  modoPrivacidade: "CONFIDENCIAL" | "IDENTIFICADA";
  dataInicio?: string;
  dataFim?: string;
  minRespondentes?: number;
}) {
  const { data } = await api.post("/api/gente-gestao/lideranca/ciclos", body);
  return data as { success: boolean; ciclo: GgCicloDetalheDto };
}

export async function fetchCicloDetalhe(id: string): Promise<{
  ciclo: GgCicloDetalheDto;
  perguntas: GgPerguntaLiderancaDto[];
  convites: GgConviteLiderancaDto[];
  competencias: GgCompetenciaDto[];
  pares: GgParLiderancaDto[];
  colaboradoresAtivos: GgColaboradorDto[];
}> {
  const { data } = await api.get(`/api/gente-gestao/lideranca/ciclos/${id}`);
  return data;
}

export async function updateCicloApi(id: string, body: Record<string, unknown>) {
  const { data } = await api.patch(`/api/gente-gestao/lideranca/ciclos/${id}`, body);
  return data.ciclo as GgCicloDetalheDto;
}

export async function setStatusCicloApi(id: string, status: "RASCUNHO" | "ATIVA" | "ENCERRADA") {
  const { data } = await api.post(`/api/gente-gestao/lideranca/ciclos/${id}/status`, { status });
  return data.ciclo as GgCicloDetalheDto;
}

export async function addPerguntaCicloApi(
  cicloId: string,
  body: Partial<GgPerguntaLiderancaDto> & { tipo: string; texto: string },
) {
  const { data } = await api.post(`/api/gente-gestao/lideranca/ciclos/${cicloId}/perguntas`, body);
  return data.pergunta as GgPerguntaLiderancaDto;
}

export async function updatePerguntaCicloApi(
  cicloId: string,
  perguntaId: string,
  body: Partial<GgPerguntaLiderancaDto>,
) {
  const { data } = await api.patch(`/api/gente-gestao/lideranca/ciclos/${cicloId}/perguntas/${perguntaId}`, body);
  return data.pergunta as GgPerguntaLiderancaDto;
}

export async function removePerguntaCicloApi(cicloId: string, perguntaId: string) {
  await api.delete(`/api/gente-gestao/lideranca/ciclos/${cicloId}/perguntas/${perguntaId}`);
}

export async function moverPerguntaCicloApi(cicloId: string, perguntaId: string, direcao: "up" | "down") {
  const { data } = await api.post(
    `/api/gente-gestao/lideranca/ciclos/${cicloId}/perguntas/${perguntaId}/mover`,
    { direcao },
  );
  return data.perguntas as GgPerguntaLiderancaDto[];
}

export async function gerarConvitesLiderancaApi(
  cicloId: string,
  body: { colaboradorIds?: string[]; liderIds?: string[]; todosAtivos?: boolean; setor?: string | null },
) {
  const { data } = await api.post<{ success: boolean; criados: number }>(
    `/api/gente-gestao/lideranca/ciclos/${cicloId}/convites`,
    body,
  );
  return data.criados;
}

export async function marcarEnviadoLiderancaApi(cicloId: string, conviteId: string) {
  await api.post(`/api/gente-gestao/lideranca/ciclos/${cicloId}/convites/${conviteId}/marcar-enviado`);
}

export async function fetchResultadosLideranca(id: string): Promise<GgLiderancaResultadosDto> {
  const { data } = await api.get<{ success: boolean; resultados: GgLiderancaResultadosDto }>(
    `/api/gente-gestao/lideranca/ciclos/${id}/resultados`,
  );
  return data.resultados;
}

export function csvCicloConvitesUrl(id: string): string {
  return `/api/gente-gestao/lideranca/ciclos/${id}/convites.csv`;
}

export function csvCicloRespostasUrl(id: string): string {
  return `/api/gente-gestao/lideranca/ciclos/${id}/resultados.csv`;
}

export function pdfLiderUrl(cicloId: string, liderId: string): string {
  return `/api/gente-gestao/lideranca/ciclos/${cicloId}/lideres/${liderId}.pdf`;
}

export async function downloadGgFile(url: string, filename: string, mime: string): Promise<void> {
  const { data } = await api.get<Blob>(url, { responseType: "blob" });
  const blob = new Blob([data], { type: mime });
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}
